import React from 'react'
import styles from './Style.module.css'

export const OptionCard = ({title, text, handleClick, selected, disabled}) => {

  return (
    <div 
      className={`${styles.optionCard} ${disabled ? styles.disabled : ''} btn`} 
      onClick={handleClick}
      selected={selected}
    >
        <div className={styles.left}>
          <h4>{title}</h4>
          <p>{text}</p>
        </div>
        <div className={`${styles.goIcon} icn angle-pc-800`} />
    </div>
  )
}
